import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchCurrentUser, logout as apiLogout } from "../api/api";

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (!token) {
      setLoading(false);
      return;
    }

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    fetchCurrentUser()
      .then((data) => {
        setUser(data);
        localStorage.setItem("user", JSON.stringify(data));
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  async function refreshUser() {
    const data = await fetchCurrentUser();
    setUser(data);
    localStorage.setItem("user", JSON.stringify(data));
    return data;
  }

  function login(tokens, userData) {
    localStorage.setItem("token", tokens.access_token);
    localStorage.setItem("refresh_token", tokens.refresh_token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  }

  async function logout() {
    const refreshToken = localStorage.getItem("refresh_token");
    try {
      await apiLogout(refreshToken);
    } catch {
      // ignore — proceed to clear local session regardless
    }
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
    setUser(null);
  }

  const role = user?.role?.name || null;

  return (
    <AuthContext.Provider value={{ user, role, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
